(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('fixation', {
            // parent: 'entity',
            parent: 'app',
            url: '/fixation?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.fixation.home.title'
            },
            views: {
                // 'content@': {
                'fixation@': {
                    templateUrl: 'app/entities/fixation/fixations.html',
                    controller: 'FixationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fixation');
                    $translatePartialLoader.addPart('qtyUnitType');
                    $translatePartialLoader.addPart('priceType');
                    $translatePartialLoader.addPart('currencyType');
                    $translatePartialLoader.addPart('wtUnitType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fixation-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/fixation/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.fixation.detail.title'
            },
            views: {
                // 'content@': {
                'fixation-detail@': {
                    templateUrl: 'app/entities/fixation/fixation-detail.html',
                    controller: 'FixationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fixation');
                    $translatePartialLoader.addPart('qtyUnitType');
                    $translatePartialLoader.addPart('priceType');
                    $translatePartialLoader.addPart('currencyType');
                    $translatePartialLoader.addPart('wtUnitType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Fixation', function($stateParams, Fixation) {
                    return Fixation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'fixation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('fixation-detail.edit', {
            // parent: 'fixation-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/fixation/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fixation/fixation-dialog.html',
                    controller: 'FixationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fixation', function(Fixation) {
                            return Fixation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fixation.new', {
            // parent: 'fixation',
            parent: 'app',
            // url: '/new',
            url: '/fixation/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fixation/fixation-dialog.html',
                    controller: 'FixationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                fixDate: null,
                                quantity: null,
                                unitType: null,
                                price: null,
                                priceType: null,
                                currency: null,
                                priceUnit: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fixation', null, { reload: true });
                }, function() {
                    $state.go('fixation');
                });
            }]
        })
        .state('fixation.edit', {
            // parent: 'fixation',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/fixation/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fixation/fixation-dialog.html',
                    controller: 'FixationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fixation', function(Fixation) {
                            return Fixation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fixation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fixation.delete', {
            // parent: 'fixation',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/fixation/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fixation/fixation-delete-dialog.html',
                    controller: 'FixationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Fixation', function(Fixation) {
                            return Fixation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fixation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );
        
    }

})();
